import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { AutoBlockSetting } from './model';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'userAutoBlock';

export interface State extends EntityState<AutoBlockSetting>, Status {}

export const adapter = createEntityAdapter<AutoBlockSetting>({
    selectId: (user) => user.userId,
});

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    on(actions.loadUsersAutoBlockSuccess, (state, { data }) => adapter.setAll(data, { ...state, loaded: true })),

    on(actions.enableUsersAutoBlock, (state, _) => ({ ...state, updating: true })),

    on(actions.enableUsersAutoBlockSuccess, (state, { users }) =>
        adapter.upsertMany(users, { ...state, updating: false }),
    ),

    on(actions.updateLastModifiedUserAutoBlockSuccess, (state, { user }) =>
        adapter.upsertOne(user, { ...state, updating: false }),
    ),

    on(actions.enableUsersAutoBlockFailure, (state, { error }) => ({ ...state, error, updating: false })),

    on(actions.disableUsersAutoBlock, (state, _) => ({ ...state, updating: true })),

    on(actions.disableUsersAutoBlockSuccess, (state, { users }) =>
        adapter.upsertMany(users, { ...state, updating: false }),
    ),
    on(actions.disableUsersAutoBlockFailure, (state, { error }) => ({ ...state, error, updating: false })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
